import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowLeft, TrendingUp, BarChart3 } from "lucide-react";
import { useNavigate, Link } from "react-router-dom";
import { PageHead } from "@/components/seo/PageHead";

export default function CasesAmazon() {
  const navigate = useNavigate();
  
  return (
    <>
      <PageHead
        title="Études de cas Amazon — Résultats & Trajectoires | Cosmos Wave"
        description="Découvrez nos études de cas Amazon : croissance volume, chiffre d'affaires, optimisations SEO et Ads avec résultats mesurés."
        canonical="https://www.cosmos-wave.com/cases/amazon"
        pageType="website"
      />
      <div className="min-h-screen bg-background">

      {/* Hero Section */}
      <section className="py-12 lg:py-16 xl:py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-card/10 via-transparent to-card/10" />
        <div className="container mx-auto px-6 xl:px-8 2xl:px-12 relative">
          <div className="max-w-4xl xl:max-w-5xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl xl:text-6xl 2xl:text-7xl font-bold tracking-tight mb-6 bg-gradient-to-r from-foreground to-foreground/70 bg-clip-text text-transparent">
              Études Amazon
            </h1>
            <p className="text-xl xl:text-2xl text-muted-foreground mb-8 leading-relaxed max-w-3xl mx-auto">
              Trajectoires réelles issues de nos interventions.
            </p>
            
            {/* Scroll indicator */}
            <div className="flex flex-col items-center mt-12 lg:mt-16">
              <p className="text-sm text-muted-foreground mb-3">Découvrez nos cas Amazon</p>
              <div className="w-6 h-10 border-2 border-primary/30 rounded-full flex justify-center">
                <div className="w-1 h-3 bg-primary rounded-full mt-2 animate-bounce"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Cards Section */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <Card className="group p-8 border-border bg-card hover:bg-card/80 transition-all duration-300 cursor-pointer hover:scale-[1.02] hover:shadow-xl hover:shadow-primary/10" onClick={() => navigate("/cases/amazon/volume-ventes")}>
              <div className="flex items-start justify-between mb-6">
                <Badge variant="outline" className="text-primary border-primary/30 bg-primary/10">
                  Amazon
                </Badge>
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-primary/20 to-primary/10 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <TrendingUp className="w-8 h-8 text-primary" />
                </div>
              </div>
              <h3 className="text-2xl font-bold mb-3 group-hover:text-primary transition-colors">Volume de ventes</h3>
              <p className="text-muted-foreground mb-6">De 0 à 22 199 unités en 23 mois</p>
              <Button variant="outline" className="w-full group-hover:border-primary group-hover:text-primary transition-colors">
                Voir l'étude
              </Button>
            </Card>

            <Card className="group p-8 border-border bg-card hover:bg-card/80 transition-all duration-300 cursor-pointer hover:scale-[1.02] hover:shadow-xl hover:shadow-accent/10" onClick={() => navigate("/cases/amazon/chiffre-affaires")}>
              <div className="flex items-start justify-between mb-6">
                <Badge variant="outline" className="text-primary border-primary/30 bg-primary/10">
                  Amazon
                </Badge>
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-accent/20 to-accent/10 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <BarChart3 className="w-8 h-8 text-accent" />
                </div>
              </div>
              <h3 className="text-2xl font-bold mb-3 group-hover:text-accent transition-colors">Chiffre d'affaires</h3>
              <p className="text-muted-foreground mb-6">De 0 € à 704 990 € en 23 mois</p>
              <Button variant="outline" className="w-full group-hover:border-accent group-hover:text-accent transition-colors">
                Voir l'étude
              </Button>
            </Card>
          </div>
        </div>
      </section>
      </div>
    </>
  );
}